/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSinh } from '../../factoriesAny.js';
export var sinhDependencies = {
  typedDependencies,
  createSinh
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesSinh.generated.js
// module id = null
// module chunks = 